// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"4db493e0","453":"11f5d37f","537":"58d76706"}[chunkId] + ".chunk.js";
};